<script>
import vClickOutside from "v-click-outside";
import FormatMessage from "./format-message";

/**
 * Message component
 */
export default {
  components: {
    FormatMessage,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    currentUserId: {
      type: [String, Number],
      required: true,
    },
    textMessages: {
      type: Object,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    },
    messages: {
      type: Array,
      required: true,
    },
    roomUsers: {
      type: Array,
      default: () => [],
    },

    roomFooterRef: {
      type: HTMLDivElement,
    },

    textFormatting: {
      type: Boolean,
      required: true,
    },

    hideOptions: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      hoverMessageId: null,
      imageLoading: false,
      imageHover: false,
      messageHover: false,
      optionsOpened: false,
      optionsClosing: false,
      menuOptionsTop: 0,
      messageReaction: [],
      newMessage: {},
      emojiOpened: false,
      imageResponsive: "",
    };
  },
  watch: {
    message: {
      immediate: true,
      handler() {
       
      },
    },
  },
  mounted() {
    if (!this.message.seen && this.message.sender_id !== this.currentUserId) {
      this.$emit("addNewMessage", {
        _id: this.message._id,
        index: this.index,
      });
    }
    this.imageResponsive = {
      maxHeight: this.$refs.imageRef.clientWidth - 18,
      loaderTop: this.$refs.imageRef.clientWidth / 2,
    };
  },
  computed: {
    showDate() {
      return (
        this.index > 0 &&
        this.message.date !== this.messages[this.index - 1].date
      );
    },

   
  
  },
  methods: {
   
  },
};
</script>

<template>
  <ul
    class="list-unstyled mb-0"
    v-if="message.content !== '' "
  >
    <li :class="{ right: message.align === 'right' }">
      <div
        class="conversation-list"
        ref="imageRef"
       
      >
       
        <div class="user-chat-content">
          <div class="ctext-wrap">
            <div class="ctext-wrap-content">
              <div>
                <span class="imedil_t">{{ message.user }}:</span>
                <format-message
                  :content="this.message.content"
                  :textFormatting="textFormatting"
                ></format-message>
              </div>         
              <p class="chat-time mb-0">
                <i class="ri-time-line align-middle pr-1"></i>
                <span class="align-middle">{{ message.time }}</span>
              </p>
            </div>
            <div class="text-timestamp">
              <span>{{ message.timestamp }}</span>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.image-container {
  width: 250px;
  max-width: 100%;
}

.image-reply-container {
  width: 70px;
}

.message-image {
  position: relative;
  background-color: var(--chat-message-bg-color-image) !important;
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  height: 250px;
  width: 250px;
  max-width: 100%;
  border-radius: 4px;
  margin: 4px auto 5px;
  transition: 0.4s filter linear;
}

.message-image-reply {
  height: 70px;
  width: 70px;
  margin: 4px auto 3px;
}

.image-loading {
  filter: blur(3px);
}

.reply-message {
  background: var(--chat-message-bg-color-reply);
  border-radius: 4px;
  margin: -1px -5px 8px;
  padding: 8px 10px;

  .reply-username {
    color: var(--chat-message-color-reply-username);
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 2px;
  }

  .reply-content {
    font-size: 12px;
    color: var(--chat-message-color-reply-content);
  }
}

.text-username {
  font-size: 13px;
  color: var(--chat-message-color-username);
  margin-bottom: 2px;
}

.username-reply {
  margin-bottom: 5px;
}

.text-timestamp {
  font-size: 10px;
  color: var(--chat-message-color-timestamp);
  text-align: right;
}

.file-message {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 3px;

  span {
    max-width: 100%;
  }

  .icon-file svg {
    margin-right: 5px;
  }
}

.right {
  .options-container {
    right: -40px;
    .wrapper.message-reactions {
      right: -10px;
    }
  }
}
.options-me {
  background: var(--chat-message-bg-color-me);
}

.options-image .blur-container {
  background: rgba(255, 255, 255, 0.6);
  border-bottom-left-radius: 15px;
}

.image-buttons {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 55%,
    rgba(0, 0, 0, 0.02) 60%,
    rgba(0, 0, 0, 0.05) 65%,
    rgba(0, 0, 0, 0.1) 70%,
    rgba(0, 0, 0, 0.2) 75%,
    rgba(0, 0, 0, 0.3) 80%,
    rgba(0, 0, 0, 0.5) 85%,
    rgba(0, 0, 0, 0.6) 90%,
    rgba(0, 0, 0, 0.7) 95%,
    rgba(0, 0, 0, 0.8) 100%
  );

  svg {
    height: 26px;
    width: 26px;
  }

  .button-view,
  .button-download {
    position: absolute;
    bottom: 6px;
    left: 7px;
  }

  :first-child {
    left: 40px;
  }

  .button-view {
    max-width: 18px;
    bottom: 8px;
  }
}

.message-reactions {
  position: relative;
  top: 10px !important;
  right: 0 !important;
}

.menu-options {
  right: 15px;
}

.menu-left {
  right: -118px;
}

.button-reaction {
  display: inline-flex;
  align-items: center;
  border: var(--chat-message-border-style-reaction);
  outline: none;
  background: var(--chat-message-bg-color-reaction);
  border-radius: 4px;
  margin: 4px 2px 0;
  transition: 0.3s;
  padding: 0;
  font-size: 18px;
  line-height: 23px;

  span {
    font-size: 11px;
    font-weight: 500;
    min-width: 7px;
    color: var(--chat-message-color-reaction-counter);
  }

  &:hover {
    border: var(--chat-message-border-style-reaction-hover);
    background: var(--chat-message-bg-color-reaction-hover);
    cursor: pointer;
  }
}

.btn:focus,
.btn.focus {
  box-shadow: none !important;
}

@media only screen and (max-width: 768px) {
  .options-container {
    right: 3px;
  }

  .menu-left {
    right: -50px;
  }
}
</style>
